<template>
  <div class="flex h-full flex-col">
    <div
      class="flex h-full grow flex-col items-center justify-around"
    >
      <!-- @vue-ignore-->
      <OnLongPress
        :options="{ delay: 5000 }"
        @trigger="onUnboxIconLongPress"
      >
        <IconUnboxDevice
          class="size-40 text-background-fg/70"
        />
      </OnLongPress>
      <div class="space-y-4">
        <div class="text-center font-bold"> Welcome! </div>
        <div class="text-center text-sm">
          Let's get started setting up your new device
        </div>
      </div>
    </div>
    <IconBrandLogo
      class="mb-2 h-auto w-[70%] self-center"
    />
    <ActionButtonPrimary @click="emit('stage-complete')">
      Set up your new device
    </ActionButtonPrimary>
  </div>

  <ServiceLogisticsLoginDrawer
    ref="serviceLogisticsLoginDrawerRef"
  />

  <BaseDrawer
    :is-open="serviceLogisticsActionsDrawerIsOpen"
    shrink
    @close="serviceLogisticsActionsDrawerIsOpen = false"
  >
    <MoreMenuItemAction
      :icon="IconExitApp"
      label="Exit"
      description="Close the application"
      @click="IActions.exitApp"
    />
  </BaseDrawer>
</template>

<script setup lang="ts">
import { OnLongPress } from "@vueuse/components"
import {
  IconExitApp,
  IconUnboxDevice,
  IconBrandLogo,
} from "@/icons"
import { IActions } from "@/androidPlugins/IActions"

const emit = defineEmits<{
  (eventName: "stage-complete"): void
}>()

const serviceLogisticsLoginDrawerRef = useTemplateRef(
  "serviceLogisticsLoginDrawerRef"
)
const serviceLogisticsActionsDrawerIsOpen = ref(false)

const onUnboxIconLongPress = async () => {
  if (serviceLogisticsLoginDrawerRef.value === null) return

  const { isCanceled } =
    await serviceLogisticsLoginDrawerRef.value.reveal()

  serviceLogisticsActionsDrawerIsOpen.value = !isCanceled
}
</script>
